import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'src/redux/store';
import { getListaColunas, getListaTickets } from 'src/redux/slices/chamados';
import useAuth from 'src/hooks/useAuth';
import useNovoChamado from 'src/hooks/useNovoChamado';
import { NovoChamado } from 'src/sections/@dashboard/tickets/ChamadosNovoChamado';
import ChamadosDetalhes from 'src/sections/@dashboard/tickets/ChamadosDetalhes';
import ChamadosSidebar from 'src/sections/@dashboard/tickets/ChamadosSidebar';
import ChamadosHeader from 'src/sections/@dashboard/chamados/ChamadosHeader';
import { Inbox } from 'lucide-react';
import { actionListaCaixasEntrada } from 'src/actions/chamados/actionChamadosConfig';
import { Card } from 'src/@/components/ui/card';
import { CHAMADOS_DESIGN } from 'src/sections/@dashboard/chamados/Chamados.design';

const D = CHAMADOS_DESIGN;

export default function ChamadosChat() {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { chamado, comentarios_chamado } = useSelector((state) => state.chamados);
  const { novoChamadoProps, handleOpenNovoChamado } = useNovoChamado();
  const [listaCaixas, setListaCaixas] = useState([]);
  const [caixaSelecionada, setCaixaSelecionada] = useState('');

  async function buscarCaixasEntrada() {
    try {
      const response = await actionListaCaixasEntrada(`?cliente_id=${user.clienteId}`);
      setListaCaixas(response.data.data);
    } catch (error) { }
  }

  useEffect(() => {
    buscarCaixasEntrada();
    dispatch(getListaColunas({ setorId: user.setorId, usuarioId: user.id, filial: '' }));
    dispatch(getListaTickets({ setorId: user.setorId, usuarioId: user.id, filial: '' }));
  }, [dispatch]);

  return (
    <div className={D.page.container}>
      <ChamadosHeader onCriarChamado={handleOpenNovoChamado} />

      <div className="flex-1 flex gap-2 p-3 overflow-hidden min-h-0">
        {/* Sidebar — Ticket list */}
        <Card className="w-[420px] min-w-[380px] flex-shrink-0 flex flex-col p-0">
          <ChamadosSidebar
            handleOpenNovoChamado={handleOpenNovoChamado}
            listaCaixas={listaCaixas}
            caixaSelecionada={caixaSelecionada}
            onChangeCaixa={(value) => setCaixaSelecionada(value)}
          />
        </Card>

        {/* Main content — Conversation + Details */}
        <Card className="flex-1 flex flex-col min-w-0">
          {chamado ? (
            <ChamadosDetalhes
              isDialog={false}
              chamado={chamado}
              comentarios={comentarios_chamado}
              isOpen={true}
              onClose={() => { }}
            />
          ) : (
            <div className="flex flex-col items-center justify-center h-full p-12 text-center">
              <div className="w-16 h-16 bg-gray-50 dark:bg-neutral-800 rounded-2xl flex items-center justify-center mb-5 text-gray-300 dark:text-neutral-600">
                <Inbox size={28} strokeWidth={1.5} />
              </div>
              <h3 className="text-base font-bold text-gray-900 dark:text-gray-100 mb-1.5">Nenhum chamado selecionado</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400 max-w-sm">
                Selecione um chamado na lista ao lado para ver os detalhes, conversas e arquivos.
              </p>
            </div>
          )}
        </Card>
      </div>

      <NovoChamado {...novoChamadoProps} />
    </div>
  );
}
